import { ReactComponent as IconPin } from "@/assets/svgs/icon-pin.svg";
import { ReactComponent as IconMenu } from "@/assets/svgs/menu-dark.svg";
import Popover from '@/components/Popover';
import addressTypes from '@/constants/address-type';
import toastType from '@/constants/toast-type/index';
import ETR_API from "@/services/api/etr";
import classname from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import TableRowInput from './table-row-input';

const TableRow = ({
	data,
	onEdit,
	fetchEtr,
	checkDuplicate,
	addToastMessage,
	columnWidth,
	...TableRow
}) => {
	const [filterVisible, setFilterVisible] = useState(false)
	const [isEdit, setIsEdit] = useState(false)
	const referenceRef = useRef(null)

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {
		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}

		setFilterVisible(false)
	}

	const handleEdit = useCallback(() => {
		setIsEdit(true);
		setFilterVisible(false);
		if (typeof onEdit.current === 'function') {
			onEdit.current();
		}
	}, [onEdit]);

	const addressBookRow = classname({
		"address-book__table__row": true,
		"address-book__table__row--active": filterVisible,
	})

	async function handlePinned() {
		if (data.type === addressTypes.saved) {
			const payload = {
				isPitstopAddress: false,
				pin: data.isPinned ? false : true,
				orgName: data.name,
				walletAddress: data.walletAddress,
				email: data.email.toLowerCase()
			}

			const [error] = await ETR_API.updateSavedAddress(payload, data.id);

			if (error) {
				return addToastMessage(error, toastType.error)
			}
		}

		if (data.type === addressTypes.pitstop) {
			const payload = {
				isPitstopAddress: true,
				pin: data.isPinned ? false : true,
			}

			const [error] = await ETR_API.updateSavedAddress(payload, data.id);

			if (error) {
				return addToastMessage(error, toastType.error)
			}
		}

		addToastMessage('Address updated successfully', toastType.success)
		fetchEtr()
	}

	async function handleDelete() {
		const [error] = await ETR_API.deleteSavedAddress(data.id);
		if (error) {
			return addToastMessage(error, toastType.error)
		}

		addToastMessage('Address deleted successfully', toastType.success)
		fetchEtr()
	}

	return (
		<>
			{isEdit && (
				<TableRowInput
					data={data}
					isEdit={true}
					setIsEdit={setIsEdit}
					fetchEtr={fetchEtr}
					checkDuplicate={checkDuplicate}
					addToastMessage={addToastMessage}
				/>
			)}
			{!isEdit && (
				<div className={addressBookRow} {...TableRow}>
					<div className="address-book__table__col address-book__table__col--black" data-testid="address-name" style={{ ...columnWidth?.find(s => s.column === 'name')?.style }}>
						{data.isPinned && (
							<span className="address-book__pin">
								<IconPin />
							</span>
						)}
						<div className="address-book__table__col__text">
							{data.name}
						</div>
					</div>
					<div className="address-book__table__col" style={{ ...columnWidth?.find(s => s.column === 'walletAddress')?.style }}>
						<div className="address-book__table__col__text">
							{data.walletAddress}
						</div>
					</div>
					<div className="address-book__table__col" style={{ ...columnWidth?.find(s => s.column === 'email')?.style }}>
						<div className="address-book__table__col__text">
							{data.email}
						</div>
					</div>
					<div className="address-book__table__col address-book__table__col--menu" style={{ ...columnWidth?.find(s => s.column === 'action')?.style }}>
						<span className="address-book__ellipsis">
							<Popover visible={filterVisible}
								options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
							>
								<Popover.Trigger>
									<IconMenu
										data-testid="icon-menu"
										id="icon-menu"
										onClick={(e) => {
											e.stopPropagation()
											if (filterVisible) {
												return
											}
											setFilterVisible(true)
										}}
									/>
								</Popover.Trigger>
								<Popover.Content>
									<div className="address-book__menu-vertical" ref={referenceRef} >
										{data.type === addressTypes.saved && (
											<>
												<div className="address-book__menu-vertical__item"
													onClick={handleEdit}
												>
													Edit
												</div>
												<div className="address-book__menu-vertical__item"
													onClick={() => {
														handlePinned().catch((error) => {
															console.error('Failed to updated saved pinned:', error);
														})
														setFilterVisible(false)
													}}
												>
													{data.isPinned ? "Unpin" : "Pin"}
												</div>
												<div className="address-book__menu-vertical__item address-book__menu-vertical__item--error"
													onClick={() => {
														handleDelete().catch((error) => {
															console.error('Failed to delete:', error);
														})
														setFilterVisible(false)
													}}
												>
													Delete
												</div>
											</>
										)}
										{data.type === addressTypes.pitstop && (
											<div className="address-book__menu-vertical__item"
												onClick={() => {
													handlePinned().catch((error) => {
														console.error('Failed to updated pitstop pinned:', error);
													})
													setFilterVisible(false)
												}}
											>
												{data.isPinned ? "Unpin" : "Pin"}
											</div>
										)}
									</div>
								</Popover.Content>
							</Popover>
						</span>
					</div>
				</div>
			)}
		</>

	)
}

export default TableRow;
